import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import PageContainer from '../PageContainer/PageContainer'
import AccountHolderReview from './AccountHolderReview/AccountHolderReview'
import FinancialAccountReview from './FinancialAccountReview/FinancialAccountReview'
import styles from './ReviewAndSubmit.module.scss'
import { createOnboardingCompletion } from 'utils/apiRequest'
import { BaseComponent } from 'belle-js'
import { setInvalidOnboardingToken } from 'utils/tokens'
import Analytics from 'analytics'
import { getLastSection } from 'utils/financialAccountTypeNavigation'

class ReviewAndSubmit extends BaseComponent {

  constructor (props) {
    super(props)
    this.state = { isLoading: false }
  }

  render () {
    const description = [
      `You can submit the account information you filled in to Ellevest Private Wealth Management at any time.
      However, we do encourage you to review each section carefully prior to submission.
      Click on “Update” under the relevant section to review and fill in any applicable empty fields.`
    ]

    const {
      goOnboardingConfirmation,
      financialAccounts,
      isLoading,
      hide,
      overview,
      prospect,
      isMobile,
    } = this.props

    const primaryButtonClasses = classnames(
      'button',
      'button--primary',
      styles.smallButton
    )

    const goToConfirmation = async () => {
      this.setState({ isLoading: true })
      await createOnboardingCompletion()
        .then(() => {
          this.setState({ isLoading: false })
          goOnboardingConfirmation()
          setInvalidOnboardingToken()
        })

      Analytics.track('User clicks Submit')
    }


    let prevPageInfo = {
      name: 'Employment Details',
      to: '/onboarding/account_holder/employment_details',
      showBackWord: true
    }

    const { onboardingFinancialAccountsVisible } = prospect

    if (onboardingFinancialAccountsVisible) {
      prevPageInfo = getLastSection(financialAccounts)
    }

    return (
      <div className={styles.ReviewAndSubmit}>
        <PageContainer
          prevPageInfo={prevPageInfo}
          isMobile={isMobile}
          name="Review & Submit"
          description={description}
          hide={hide || isLoading}
          isLoading={this.state.isLoading || isLoading}>
          <AccountHolderReview
            personalInformationComplete={overview.aboutYou.personalInformation.complete}
            identityVerificationComplete={overview.aboutYou.identityVerification.complete}
            employmentDetailsComplete={overview.aboutYou.employmentDetails.complete} />
          {prospect.onboardingFinancialAccountsVisible &&
            <FinancialAccountReview
              accountsStatusOverview={overview.yourAccounts}
              financialAccounts={financialAccounts} />
          }
          <button
            className={primaryButtonClasses}
            onClick={goToConfirmation}
            type="submit"
            data-test-id="reviewAndSubmit__submit__cta">
              Submit
          </button>
        </PageContainer>
      </div>
    )
  }

}

ReviewAndSubmit.propTypes = {
  goOnboardingConfirmation: PropTypes.func.isRequired,
  hide: PropTypes.bool.isRequired,
  prospect: PropTypes.object.isRequired,
  overview: PropTypes.object.isRequired,
}

export default ReviewAndSubmit



// WEBPACK FOOTER //
// ./src/components/Onboarding/ReviewAndSubmit/ReviewAndSubmit.jsx